import { render, staticRenderFns } from "./comments_form_pl.vue?vue&type=template&id=6d50476f&scoped=true"
import script from "./comments_form_pl.vue?vue&type=script&lang=js"
export * from "./comments_form_pl.vue?vue&type=script&lang=js"
import style0 from "./comments_form_pl.vue?vue&type=style&index=0&id=6d50476f&prod&scoped=true&lang=less"
import style1 from "./comments_form_pl.vue?vue&type=style&index=1&id=6d50476f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50476f",
  null
  
)

export default component.exports